import { formatRunDuration } from './run-timing'

interface Props {
  startedAt?: string | null
  now: number
}

export function RunProgress({ startedAt, now }: Props) {
  const elapsed = formatRunDuration(startedAt, null, now)

  return (
    <div className="rounded-lg border border-st-info/40 bg-st-info-bg/40 px-4 py-3">
      <div className="flex items-center gap-2.5">
        <span className="size-2 shrink-0 animate-pulse rounded-full bg-st-info" />
        <span className="text-14 font-medium text-ink">Investigating</span>
        {elapsed !== '—' ? (
          <span className="ml-auto text-12 tabular-nums text-ink-3">{elapsed} elapsed</span>
        ) : null}
      </div>
      <div className="mt-2.5 h-1 overflow-hidden rounded-full bg-st-info-bg">
        <div className="h-full w-1/3 animate-pulse rounded-full bg-st-info" />
      </div>
    </div>
  )
}

export function RunQueued() {
  return (
    <div className="rounded-lg border border-line bg-bg-elev px-4 py-3 text-sm text-ink-2">
      Queued — waiting to start
    </div>
  )
}
